import { createSlice } from "@reduxjs/toolkit";

export const problemSlice = createSlice({
  name: "problem",
  initialState: {
    loading: false,
    formSubmitLoading: false,
    problemList: [],
    listCount: 0,
    problemData: {},
    checkApprove: false,
    RejectMode: false,
    problemRejectData: {},
    problemTypeList: [],
    problemTypeParams: { page: 1, page_size: 10, no_of_pages: 0, search: "" },
    vehicleList: [],
    vehicleParams: { page: 1, page_size: 10, no_of_pages: 0, search: "" },
    customerList: [],
    customerParams: { page: 1, page_size: 10, no_of_pages: 0, search: "" },
    hpNumberList: [],
    hpNumberParams: { page: 1, page_size: 10, no_of_pages: 0, search: "" },
    hpNumberData: {},
    serviceTypeList: [],
    serviceTypeParams: { page: 1, page_size: 10, no_of_pages: 0, search: "" },
    problemParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      start_date: "",
      end_date: "",
      problem_type: "",
      service_type: "",
    },
    drawer: false,
    filterStatus: false,
    approveData: {},
    error_msg: null,
  },
  reducers: {
    getProblemList: (state) => {
      return { ...state, loading: true };
    },
    getProblemApprovalList: (state) => {
      return { ...state, loading: true };
    },
    problemListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.count / state.problemParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.count,
        problemList: action.payload.results,
        loading: false,
        problemParams: { ...state.problemParams, no_of_pages: noofpages },
      };
    },
    addProblem: (state) => {
      return { ...state, formSubmitLoading: true };
    },
    addProblemSuccessful: (state) => {
      return { ...state, formSubmitLoading: false };
    },
    getProblemDoc: (state) => {
      return { ...state, loading: true, problemData: {} };
    },
    problemDocSuccessful: (state, action) => {
      return { ...state, problemData: action.payload, loading: false };
    },
    getProblemCheckApprove: (state) => {
      return { ...state, loading: true, checkApprove: false };
    },
    problemCheckApproveSuccessful: (state, action) => {
      return { ...state, loading: false, checkApprove: action.payload };
    },
    problemApproval: (state) => {
      return { ...state, loading: true };
    },
    isRejectModelVisible: (state, action) => {
      return { ...state, RejectMode: action.payload, problemRejectData: {}, loading: false };
    },
    rejectModelInputChangeValue: (state, action) => {
      return {
        ...state,
        problemRejectData: {
          ...state.problemRejectData,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    problemDelete: (state) => {
      return { ...state, loading: false };
    },
    setProblemParams: (state, action) => {
      return { ...state, problemParams: action.payload };
    },
    isDrawerVisible: (state, action) => ({ ...state, drawer: action.payload }),
    checkFilterStatus: (state, action) => ({ ...state, filterStatus: action.payload }),
    FilterInputChangeValue: (state, action) => ({
      ...state,
      problemParams: { ...state.problemParams, [action.payload.key]: action.payload.value },
    }),
    // Problem Type dropdown
    getProblemTypeDropdown: (state) => state,
    problemTypeDropdownSuccessful: (state, action) => {
      var noofpages = Math.ceil(action.payload.count / state.problemTypeParams.page_size);
      return {
        ...state,
        problemTypeList:
          state.problemTypeParams.page === 1
            ? action.payload.results
            : [...state.problemTypeList, ...action.payload.results],
        problemTypeParams: { ...state.problemTypeParams, no_of_pages: noofpages },
      };
    },
    setProblemTypeParams: (state, action) => {
      return { ...state, problemTypeParams: action.payload };
    },
    // Vehicle dropdown
    getVehicleList: (state) => state,
    vehicleListSuccessful: (state, action) => {
      var noofpages = Math.ceil(action.payload.count / state.vehicleParams.page_size);
      return {
        ...state,
        vehicleList:
          state.vehicleParams.page === 1
            ? action.payload.results
            : [...state.vehicleList, ...action.payload.results],
        vehicleParams: { ...state.vehicleParams, no_of_pages: noofpages },
      };
    },
    setVehicleParams: (state, action) => {
      return { ...state, vehicleParams: action.payload };
    },
    // Customer dropdown
    getCustomerList: (state) => state,
    customerListSuccessful: (state, action) => {
      var noofpages = Math.ceil(action.payload.count / state.customerParams.page_size);
      return {
        ...state,
        customerList:
          state.customerParams.page === 1
            ? action.payload.results
            : [...state.customerList, ...action.payload.results],
        customerParams: { ...state.customerParams, no_of_pages: noofpages },
      };
    },
    setCustomerParams: (state, action) => {
      return { ...state, customerParams: action.payload };
    },
    // HP Number dropdown
    getHpNumberList: (state) => state,
    hpNumberListSuccessful: (state, action) => {
      var noofpages = Math.ceil(action.payload.count / state.hpNumberParams.page_size);
      return {
        ...state,
        hpNumberList:
          state.hpNumberParams.page === 1
            ? action.payload.results
            : [...state.hpNumberList, ...action.payload.results],
        hpNumberParams: { ...state.hpNumberParams, no_of_pages: noofpages },
      };
    },
    setHpNumberParams: (state, action) => {
      return { ...state, hpNumberParams: action.payload };
    },
    getHpNumberDoc: (state) => {
      return { ...state, hpNumberData: {} };
    },
    hpNumberDocSuccessful: (state, action) => {
      return { ...state, hpNumberData: action.payload };
    },
    // Service Type dropdown
    getServiceTypeDropdown: (state) => state,
    serviceTypeDropdownSuccessful: (state, action) => {
      var noofpages = Math.ceil(action.payload.count / state.serviceTypeParams.page_size);
      return {
        ...state,
        serviceTypeList:
          state.serviceTypeParams.page === 1
            ? action.payload.results
            : [...state.serviceTypeList, ...action.payload.results],
        serviceTypeParams: { ...state.serviceTypeParams, no_of_pages: noofpages },
      };
    },
    setServiceTypeParams: (state, action) => {
      return { ...state, serviceTypeParams: action.payload };
    },
    getProblemApproveDoc: (state) => {
      return { ...state, approveData: {} };
    },
    problemApproveDocSuccessful: (state, action) => {
      return { ...state, approveData: action.payload };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, formSubmitLoading: false, error_msg: action.payload };
    },
  },
});

export const {
  getProblemList,
  getProblemApprovalList,
  problemListSuccessful,
  addProblem,
  addProblemSuccessful,
  getProblemDoc,
  problemDocSuccessful,
  getProblemCheckApprove,
  problemCheckApproveSuccessful,
  problemApproval,
  isRejectModelVisible,
  rejectModelInputChangeValue,
  problemDelete,
  setProblemParams,
  isDrawerVisible,
  checkFilterStatus,
  FilterInputChangeValue,
  getProblemTypeDropdown,
  problemTypeDropdownSuccessful,
  setProblemTypeParams,
  getVehicleList,
  vehicleListSuccessful,
  setVehicleParams,
  getCustomerList,
  customerListSuccessful,
  setCustomerParams,
  getHpNumberList,
  hpNumberListSuccessful,
  setHpNumberParams,
  getServiceTypeDropdown,
  serviceTypeDropdownSuccessful,
  setServiceTypeParams,
  getHpNumberDoc,
  hpNumberDocSuccessful,
  getProblemApproveDoc,
  problemApproveDocSuccessful,
  apiError,
} = problemSlice.actions;

export default problemSlice.reducer;
